import React from 'react';
import { observer } from 'mobx-react';

// Components
import * as icons from '../Icons/Icons';

const Privacy = observer(class Privacy extends React.Component {
  constructor() {
    super();
    this.toggle = this.toggle.bind(this);

    this.state = {
      reveal: false
    }
  }

  privatize() {
    let masked = '';

    for(let i = 0; i < this.props.private.length; i++) {
      masked += '•';
    }

    return masked;
  }

  toggle() {
    this.setState({
      reveal: !this.state.reveal
    });
  }

  render() {
    return(
      <span
        className={`
          privacy
          ${this.props.className ? this.props.className : ''}
          ${this.state.reveal ? 'reveal' : ''}
        `}
      >
        {/* Reveal */}
        <button
          className="privacy__toggle privacy__show"
          onClick={this.toggle}
          type="button"
          title={this.props.show}
        >
          <icons.iconEye />
          <span className="meta">{this.props.show}</span>
        </button>

        {/* Hide */}
        <button
          className="privacy__toggle privacy__hide"
          onClick={this.toggle}
          type="button"
          title={this.props.hide}
        >
          <icons.iconEyeSlash />
          <span className="meta">{this.props.hide}</span>
        </button>

        {/* Placeholder */}
        <span className="privacy__show">{this.privatize()}</span>

        {/* Private data */}
        <span className="privacy__hide">{this.props.private}</span>
      </span>
    );
  }
})

export default Privacy;



// WEBPACK FOOTER //
// ./src/app/components/Common/Privacy.js